/* eslint-disable camelcase */

export enum RescheduleReasonLabels {
  acceptable_adjustment = 'Acceptable Adjustment',
  no_fault__first_appointment = 'No Fault: First Appointment',
  no_fault__smoothing = 'No Fault: Smoothing',
  no_fault__weather_aog_holiday_road_closure = 'No Fault: Weather/AOG/Holiday/Road Closure',
  customer_issue__shipping_facility = 'Customer Issue: Shipping Facility',
  customer_issue__receiving_facility = 'Customer Issue: Receiving Facility',
  customer_issue__clerical_error_inaccurate_info = 'Customer Issue: Clerical Error/Inaccurate Info',
  customer_issue__edi_incorrect_info = 'Customer Issue: EDI Incorrect Info',
  customer_issue__customer_requested_change = 'Customer Issue: Customer Requested Change',
  carrier_issue__mechanical = 'Carrier Issue: Mechanical',
  carrier_issue__previous_shipment = 'Carrier Issue: Previous Shipment',
  carrier_issue__driver_issue = 'Carrier Issue: Driver Issue',
  carrier_issue__driving_delays = 'Carrier Issue: Driver Delays',
  carrier_failure__poor_planning = 'Carrier Failure: Poor Planning',
  carrier_failure__dishonesty = 'Carrier Failure: Dishonesty',
  carrier_issue__rejected_trailer = 'Carrier Issue: Rejected trailer',
  edi_normal_adjustment = 'EDI Normal Adjustment',
  first_appointment = 'First Appointment',
  normal_adjustment = 'Normal Adjustment',
  tf_issue__clerical_error_inaccurate_info = 'TF Issue: Clerical Error/Inaccurate Info',
  tf_issue__pricing = 'TF Issue: Pricing',
  tf_issue__loss_prevention = 'TF Issue: Loss Prevention',
  tf_issue__cm_booking_capacity = 'TF Issue: CM Booking/Capacity',
  tf_issue__tracking_tracing = 'TF Issue: Tracking/Tracing',
  tf_issue__cm_faulted = 'TF Issue: CM Faulted',
  tf_issue__acceptable_transit_adjustment = 'TF Issue: Acceptable Transit Adjustment',
  tf_issue__booking_capacity = 'TF Issue: Booking/Capacity',
  tf_issue__smoothing = 'TF Issue: Smoothing',
  tf_issue__weather_aog_holiday_road_closures = 'TF Issue: Weather/AOG/Holiday/Road Closures',
  _predicted_appt____1_ = 'Predicted Appt (+-1)',
  predicted_appt_inaccurate = 'Predicted Appt Inaccurate',
  predicted_appt_request = 'Predicted Appt Request',
  smoothing = 'Smoothing',
  tms_shipment_reschedule = 'TMS Shipment Reschedule',
  weather_aog_holiday_road_closures = 'Weather/AOG/Holiday/Road Closures',
  suggested_appointment = 'Suggested Appointment',
}

export const RescheduleReasonsDisplayOrder = [
  'customer_issue__shipping_facility',
  'customer_issue__receiving_facility',
  'customer_issue__customer_requested_change',
  'no_fault__first_appointment',
  'tf_issue__cm_booking_capacity',
  'carrier_failure__poor_planning',
  'carrier_issue__driver_issue',
  'carrier_issue__mechanical',
  'carrier_issue__driving_delays',
  'carrier_issue__rejected_trailer',
  'no_fault__weather_aog_holiday_road_closure',
  'no_fault__smoothing',
  'customer_issue__edi_incorrect_info',
  'customer_issue__clerical_error_inaccurate_info',
  'tf_issue__loss_prevention',
  'tf_issue__clerical_error_inaccurate_info',
  'tf_issue__pricing',
  'tf_issue__tracking_tracing',
  'suggested_appointment',
]
